import React from 'react'
import { MoonLoader } from 'react-spinners'

import './style.scss'

const Index = ({selectedType}) => {

    const renderType = () => {
        if(selectedType === "sms"){
            return "SMS"
        } else if(selectedType === "email"){
            return "e-post"
        }
        return null
    }

    return(
        <div className="add-channel-loader-container">
            <div className="loader">
                <MoonLoader
                size={40}
                color={"#123abc"}
                loading={true}
                />
            </div>
            <h4 className="loading-label">Setter opp ny kanal for utsendelse av {renderType()}, vennligst ikke lukk vinduet.</h4>
        </div>
    )
}

export default Index